<template>
  <div class="mask">
    <!-- 关闭订单 -->
    <div class="layer">
      <div class="lay-tit">备注</div>
      <div class="outInput">
        <el-input
          type="textarea"
          :rows="4"
          placeholder="请输入内容"
          resize="none"
          maxlength="200"
          v-model="textarea">
        </el-input>
      </div>
      <div class="layBtn">
        <button class="butStyle whiteBtn">取消</button>
        <button class="butStyle pinkBtn">确定</button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "remarks",
    data() {
      return {
        textarea: ''
      }
    },
  }
</script>

<style scoped>
  .mask{
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    /*background: rgba(0,0,0,0.5);*/
    z-index: 99;
  }
  .mask .layer{
    position: absolute;
    width: 430px;
    top: 40%;
    left: 50%;
    -webkit-transform: translate(-50%,-50%);
    -moz-transform: translate(-50%,-50%);
    -ms-transform: translate(-50%,-50%);
    -o-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
    background: #fff;
    border:1px solid #eee;
    box-shadow: 6px 6px 12px #ccc;
    padding-bottom: 19px;
  }
  .layer .lay-tit{
    height: 40px;
    line-height: 40px;
    color:#2B2727;
    font-weight: bold;
    text-indent: 14px;
    background: #eee;
    font-size: 12px;
  }
  .outInput{
    width: 406px;
    height: 97px;
    margin: 14px auto 24px;
  }
  .layBtn{
    text-align: center;
  }
  .layBtn .butStyle{
    width: 120px;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
  }
  .layBtn .butStyle + .butStyle{
    margin-left: 20px;
  }
</style>
